/* eslint-disable no-console */
/* eslint-disable @babel/no-invalid-this */
export function renderLinks(container) {
	/** Start : plotting links */
	const links = this.buildLinks(this.nodes);
	const link = container.selectAll("path.link").data(links, function (d) {
		return d.id;
	});
	// Enter any new links at the parent's previous position.
	link
		.enter()
		.append("path", "g")
		.attr("class", "link")
		.attr("d", d => {
			return this.diagonal(d.source, d.target);
		})
		.attr("stroke", function (d) {
			if (d.linkType === "source") {
				return "var(--color2-100)";
			}
			if (d.linkType === "transfrom") {
				return "var(--color6-100)";
			}
			if (d.linkType === "hidden") {
				return "transparent";
			}
			return "var(--dashboard-font-light)";
		})
		.attr("stroke-width", function (d) {
			if (d.linkType === "source") {
				return 4;
			}
			if (d.linkType === "transfrom") {
				return 4;
			}
			return 2;
		})
		.attr("stroke-dasharray", function (d) {
			return d.linkType === "dashed" ? 6 : 0;
		})
		.attr("id", function (d) {
			return d.id;
		})
		.attr("fill", "none")
		.attr("marker-start", function (d) {
			if (d.linkType === "hidden") {
				return null;
			}
			return "url(#dot)";
		})
		.attr("marker-end", function (d) {
			if (d.linkType === "hidden") {
				return null;
			}
			return "url(#dot)";
		})
		.on("click", d => {
			this.$emit("link-click", d);
		});

	container
		.selectAll("text.marker")
		.data(links)
		.enter()
		.append("text")
		.attr("class", "link-arrow")
		.attr("id", function (d) {
			return `${d.id}~arrow`;
		})
		.attr("stroke", "var(--dashboard-background)")
		.attr("stroke-width", 1)
		.attr("dy", 8.5)
		.append("textPath")
		.attr("text-anchor", "middle")

		.attr("xlink:href", function (d) {
			return `#${d.id}`;
		})
		.attr("startOffset", "50%")
		.attr("fill", "var(--dashboard-font-light)")
		.text(function (d) {
			if (d.linkType === "hidden") {
				return null;
			}
			return "▶";
		})
		.on("click", d => {
			this.$emit("link-click", d);
		});
	/** End : plotting links */
}

/**
 * It will build links based on from,to and links property of each node
 */
export function buildLinks(nodes) {
	const links = [];
	nodes.forEach(node => {
		if (node.from) {
			node.from.forEach(source => {
				const src = nodes.find(n => n.id === source.id);
				if (src) {
					links.push({
						source: src,
						target: node,
						linkType: source.linkType ? source.linkType : "default",
						id: `${src.id}->${node.id}`
					});
				}
			});
		}
		if (node.to) {
			node.to.forEach(target => {
				const trg = nodes.find(n => n.id === target.id);
				if (trg) {
					links.push({
						source: node,
						target: trg,
						linkType: target.linkType ? target.linkType : "default",
						id: `${node.id}->${trg.id}`
					});
				}
			});
		}
	});

	const extraLinks = getExtraLinks(this.root);
	extraLinks.forEach(link => {
		const from = nodes.find(n => n.id === link.from.id);
		const to = nodes.find(n => n.id === link.to.id);
		if (from && to) {
			links.push({
				source: from,
				target: to,
				linkType: link.linkType ? link.linkType : "default",
				id: `${from.id}->${to.id}`
			});
		} else if (from) {
			const target = getAletrnateHiddenNode(this.root, nodes, link, "to");
			if (target) {
				links.push({
					source: from,
					target,
					linkType: link.linkType ? link.linkType : "default",
					id: `${from.id}->${target.id}`
				});
			}
		} else if (to) {
			const source = getAletrnateHiddenNode(this.root, nodes, link, "from");
			if (source) {
				links.push({
					source,
					target: to,
					linkType: link.linkType ? link.linkType : "default",
					id: `${source.id}->${to.id}`
				});
			}
		} else {
			const source = getAletrnateHiddenNode(this.root, nodes, link, "from");
			const target = getAletrnateHiddenNode(this.root, nodes, link, "to");

			if (source && target) {
				links.push({
					source,
					target,
					linkType: link.linkType ? link.linkType : "default",
					id: `${source.id}->${target.id}`
				});
			}
		}
	});
	return links;
}
/**
 *
 * @param {*} root root object given in pros
 * @param {*} nodes computed nodes with x and y
 * @param {*} link temparary link object with raw from and to
 * @param {*} linkDirection (e.g from or to)
 */
function getAletrnateHiddenNode(root, nodes, link, linkDirection) {
	const meta = getNodeMeta(root, link[linkDirection].id);

	if (meta) {
		const src = nodes.find(n => n.id === meta.parentId);

		if (src) {
			if (src.offset && src.offset > meta.index) {
				return src;
			} else {
				return { ...src.paginationFooter, isChildNode: true };
			}
		}
	}
}
/**
 *
 * @param {*} node from which links are calculated
 */
function getExtraLinks(node) {
	const links = [];
	if (node.from) {
		node.from.forEach(from => {
			links.push(...getExtraLinks(from));
		});
	}
	if (node.to) {
		node.to.forEach(to => {
			links.push(...getExtraLinks(to));
		});
	}
	if (node.children) {
		node.children.forEach(c => {
			links.push(...getExtraLinks(c));
		});
	}
	if (node.links) {
		if (node.links.from) {
			node.links.from.forEach(from => {
				links.push({ from, to: node, linkType: from.linkType });
			});
		}
		if (node.links.to) {
			node.links.to.forEach(to => {
				links.push({ from: node, to, linkType: to.linkType });
			});
		}
	}

	return links;
}

/**
 * This will return meta information for child node
 * @param {*} node root node to check for child id
 * @param {*} id child id
 */
function getNodeMeta(node, id) {
	const index = isYourChild(node, id);

	if (index > -1) {
		return { parentId: node.id, index };
	} else {
		if (node.from) {
			for (let i = 0; i < node.from.length; i++) {
				const meta = getNodeMeta(node.from[i], id);
				if (meta && meta.index > -1) {
					return meta;
				}
			}
		}
		if (node.to) {
			for (let i = 0; i < node.to.length; i++) {
				const meta = getNodeMeta(node.to[i], id);
				if (meta && meta.index > -1) {
					return meta;
				}
			}
		}

		return null;
	}
}
/**
 * Check for direct child
 * @param {*} node parent node
 * @param {*} childid child id
 */
function isYourChild(node, childid) {
	if (node.hasChildren && node.children) {
		return node.children.findIndex(c => c.id === childid);
	} else {
		return undefined;
	}
}
/**
 * Generate path for connection link
 * @param {*} s source node
 * @param {*} d destination node
 */
export function diagonal(s, d) {
	const xoffset = this.nodeSize.width + 4;
	const yoffset = this.nodeSize.height / 2;
	const cxoffset = this.childNodeSize.width + 4;
	const cyoffset = this.childNodeSize.height / 2;
	const sx = s.x + (s.isChildNode ? cxoffset : xoffset);
	const sy = s.y + (s.isChildNode ? cyoffset : yoffset);

	const dy = d.y + (d.isChildNode ? cyoffset : yoffset);
	const dx = d.x - 4;

	const path = `M ${sx} ${sy}
				      C ${(sx + dx) / 2} ${sy},
				        ${(sx + dx) / 2} ${dy},
				        ${dx} ${dy}`;

	return path;
}
